import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import blue from '@material-ui/core/colors/blue';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import {connect} from "react-redux";
import {hideToast} from "../store/action"

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const styles1 = theme => ({
    content:{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        color: '#fff',
        padding: '5px 2px',
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: blue[700],
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    }
});

function MySnackbarContent({ classes, className, message, onClose, variant }) {
    const Icon = variantIcon[variant];

    return (
        <div className={classNames(classes[variant], classes.content, className)}>
            <span id="client-snackbar" className={`${classes.message} montserratSemiBold`}>
                <Icon className={classNames(classes.icon, classes.iconVariant)} />
                {message}
            </span>
            <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={onClose}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>
        </div>
    );
}

MySnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

class Toast extends React.Component {
    hideToast=()=>{
        const {duration,hideToast} = this.props;
        setTimeout(_=>{
            hideToast();
        },duration);
    }
    render() {
        const {
            showToast, 
            text, 
            duration, 
            hideToast,
            variant,
            anchorOrigin,
        } = this.props;
        if (showToast) {
            this.hideToast();
            return <Snackbar
              anchorOrigin={anchorOrigin}
              open={true}
              autoHideDuration={duration}
              onClose={hideToast}
            >
                <MySnackbarContentWrapper
                    onClose={hideToast}
                    variant={variant}
                    message={text}
                />
            </Snackbar>
        }

        return null;
    }
}

Toast.defaultProps = {
    duration: 3000,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    variant: "success"
};

Toast.propTypes = {
    showToast: PropTypes.bool,
    duration: PropTypes.number,
    text: PropTypes.string,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
    anchorOrigin: PropTypes.object
};

export default connect((state, ownProps) => {
    let _state = state.component;
    return {
        showToast: _state.showToast,
        duration: _state.duration,
        text: _state.text,
        anchorOrigin: _state.anchorOrigin,
        variant: _state.variant
    };

},{
    hideToast
})(Toast);


// WEBPACK FOOTER //
// ./src/components/Toast.js